var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineRefreshTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0L24,0v24H0V0H24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "{props.color}",
    d: "M2,12.8c-0.4,0-0.8-0.3-0.8-0.8C1.2,6.1,6.1,1.2,12,1.2c4.1,0,7.8,2.3,9.6,6c0.2,0.4,0,0.8-0.3,1 c-0.4,0.2-0.8,0-1-0.3c-1.6-3.2-4.8-5.1-8.3-5.1c-5.1,0-9.2,4.1-9.2,9.2C2.8,12.4,2.4,12.8,2,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "{props.color}",
    d: "M21,8.3h-4.7c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h4V2.6c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v4.9 C21.9,7.9,21.5,8.3,21,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "{props.color}",
    d: "M12,22.8c-4.1,0-7.8-2.3-9.6-6c-0.2-0.4,0-0.8,0.3-1c0.4-0.2,0.8,0,1,0.3c1.6,3.2,4.8,5.1,8.3,5.1 c5.1,0,9.2-4.1,9.2-9.2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8C22.8,17.9,17.9,22.8,12,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "{props.color}",
    d: "M3,22.2c-0.4,0-0.8-0.3-0.8-0.8v-5c0-0.4,0.3-0.8,0.8-0.8h4.7c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8h-4 v4.2C3.8,21.9,3.5,22.2,3,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    fill: "{props.color}",
    d: "M10.2,14.5L8.7,13c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l1,1l3.5-3.5c0.3-0.3,0.8-0.3,1.1,0 s0.3,0.8,0,1.1l-4,4c-0.1,0.1-0.3,0.2-0.5,0.2S10.4,14.7,10.2,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fill: "none",
    d: "M24,0v24H0V0H24z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRefreshTick);
export default __webpack_public_path__ + "static/media/vuesax-outline-refresh-tick.935ff0f87382f46bf4b4b6e6f217c82d.svg";
export { ForwardRef as ReactComponent };